
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'
import { formatPrice } from '@/common/helpers/filters/filter'
import moment from 'moment'

export default {

  components: {
    BankCardItem: () => import(/* webpackChunkName: "components" */ '@/common/components/BankCardItem.vue'),
    ComponentDropdown: () => import(/* webpackChunkName: "components" */ '@/common/components/Dropdown.vue'),
    Datepicker: () => import(/* webpackChunkName: "components" */ '@/common/components/Datepicker.vue'),
    NumberInput: () => import(/* webpackChunkName: "components" */ '@/common/components/NumberInput.vue'),
    ComponentButton: () => import(/* webpackChunkName: "components" */ '@/common/components/Button.vue'),
    ToggleSwitch: () => import(/* webpackChunkName: "components" */ '@/common/components/ToggleSwitch.vue'),
  },
  
  data: () => ({
    store,
    loading: true,
    topUp: {
      amount: 0,
      fees: null,
      digits: null,
      is_periodic: false,
      type: 'monthly',
      start_date: null,
      end_date: null
    }
  }),
  
  computed: {
    ...mapGetters([
    ]),

    account () {
      return store.data.user.account
    },

    card () {
      return store.sidepanel.dataModel
    },

    isNewCard () {
      return !this.card.digits
    }
  },

  mounted () {
    this.$bus.$on('password-checked', this.onPasswordChecked)
  },

  destroyed () {
    this.$bus.$off('password-checked', this.onPasswordChecked)
  },
  
  methods: {
    ...mapActions([
      'getTopUpDetail',
      'getTopUpFees',
      'requestTopUp'
    ]),

    getFees () {
      this.getTopUpFees({
        digits: this.isNewCard ? this.topUp.digits : this.card.digits,
        amount: this.topUp.amount
      }).then(({ data }) => {
        this.topUp.fees = data
      }, () => {
        this.topUp.fees = null
      })
    },

    onSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.checkPassword()
        }
      })
    },

    checkPassword () {
      this.showModal({
        childVue: 'check-password',
        wrapperClass: 'modal modal--xs',
        dataModel: {},
        blockLeaveBackground: true
      })
    },

    onPasswordChecked () {
      this.requestTopUp({
        ...this.topUp,
        start_date: moment(this.topUp.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.topUp.end_date).format('YYYY-MM-DD'),
        digits: this.isNewCard ? this.topUp.digits : this.card.digits,
      }).then(() => {
        this.$bus.$emit('top-up-success', this.topUp.is_periodic)
        this.showBanner('success', this.$i18n.t('banner.success.top_up_request'))
        this.hideSidePanel()
      })
    },

    formatPrice (value, currency) {
      return formatPrice(value, currency)
    }
  }
}
